<template>
  <div class="text-black media option-checkbox-values">
    <el-button :type="
      checkIfValueSelected(section, item.id) > 0
        ? 'primary'
        : 'default'
    " class="mb-1" circle @click.prevent="onSelectedValue({ section, subProduct: item })">
      <span v-if="checkIfValueSelected(section, item.id) > 0">{{
        checkIfValueSelected(section, item.id)
      }}</span>
      <i v-else class="el-icon-plus"></i>
    </el-button>
    <div class="media-body d-flex flex-column">
      <span>{{ item.name }}</span>
      <div v-if="item.hasOptions && item.options" v-html="getFormattedSelectedItems(item.options)"></div>
    </div>
    <div class="price text-center">
      {{ item.price | currency }}
    </div>
    <div class="remove clickable" :class="
      checkIfValueSelected(section, item.id) > 0 ? 'show' : 'hide'
    " @click="onClearSelectedValue({ section, value: item.id })">
      <i class="el-icon-delete text-danger font-weight-bolder"></i>
    </div>
  </div>
</template>
<script>
import {
  formatSelectedItems,
  clone
} from "@/utilities/helper";
export default {
  props: {
    item: Object,
    section: Object,
    cloneSections: Array,
  },
  computed: {
    checkIfValueSelected() {
      return (section, value_id) => {
        if (!section.selected_items) return 0;
        if (!Array.isArray(section.selected_items)) return 0;
        const item = section.selected_items.find((x) => x.id == value_id);
        return item ? item.quantity : 0;
      };
    },
    getFormattedSelectedItems() {
      return (options) => {
        return formatSelectedItems(options);
      };
    },
  },
  methods:{
    onSelectedValue(data){
      this.$emit("onSelectedValue", data)
    },
    onClearSelectedValue(data) {
      const sectionFound = this.cloneSections.find(
        (section) => section.id == data.section.id
      );

      if (sectionFound?.subProducts?.length) {
        const cloneSubProductToClear = sectionFound.subProducts.find(
          (p) => p.id == data.value
        );

        if (cloneSubProductToClear) {
          let originalSubProductIndex = data.section.subProducts.findIndex(
            (product) => product.id == data.value
          );

          this.$set(
            data.section.subProducts[originalSubProductIndex],
            "options",
            clone(cloneSubProductToClear.options)
          );
        }
      }
      data.section.selected_items = data.section.selected_items.filter(
        (x) => x.id != data.value
      );
      data.section.selected = data.section.selected.filter(
        (x) => x != data.value
      );
    },
  }
}
</script>